import React from 'react';
import ReactPlayer from 'react-player/file';

import { VimeoWrapper } from './styles';
import { LiveClassVideoPlayerProps } from './videoProvider';

const LiveClassBunnyComponent: React.FC<LiveClassVideoPlayerProps> = ({ url }) => (
  <VimeoWrapper className="" hasChat={url?.includes('event')}>
    {url && (
      <ReactPlayer
        url={url}
        playing
        progressInterval={950}
        width="100%"
        height="100%"
        controls
        config={{
          attributes: {
            controlsList: 'nodownload',
            disablePictureInPicture: true,
          },
        }}
      />
    )}
  </VimeoWrapper>
);

export default LiveClassBunnyComponent;
